import React from 'react';
import { FileQuestion, Mail, AlertCircle } from 'lucide-react';
export function LostCertificates() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1157">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1158">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1159">
          <div className="flex items-center justify-center mb-4" data-id="element-1160">
            <FileQuestion className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-1161" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-1162">
              Lost Certificates
            </h1>
          </div>
        </div>

        {/* Main Content */}
        <div className="space-y-8" data-id="element-1163">
          <div className="bg-gray-50 rounded-lg p-8" data-id="element-1164">
            <p className="text-lg leading-relaxed text-gray-700 mb-6" data-id="element-1165">
              If you have lost or misplaced a certificate to a class you
              attended with Desert Sage Seminars, you will need a replacement
              before you attempt to renew your license. There may be a charge
              for a lost certificate if necessary information is not provided or
              snail mail is requested.
            </p>

            <div className="bg-white rounded-lg p-6 border-2 border-brand-purple-200 mb-6" data-id="element-1166">
              <div className="flex items-start mb-6" data-id="element-1167">
                <Mail className="w-6 h-6 text-brand-purple-600 mr-3 mt-1 flex-shrink-0" data-id="element-1168" />
                <div data-id="element-1169">
                  <p className="text-base text-gray-700 mb-4" data-id="element-1170">
                    For a replacement, contact us via e-mail at{' '}
                    <a href="mailto:Administration@DesertSageSeminars.com" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold" data-id="element-1171">
                      Administration@DesertSageSeminars.com
                    </a>{' '}
                    or click on CONTACT on the Home Page to send direct email
                    with your request including the name, date and location of
                    the class.
                  </p>
                </div>
              </div>

              <p className="text-base text-gray-700" data-id="element-1172">
                We verify your attendance and then send a replacement
                certificate back by email.
              </p>
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4" data-id="element-1173">
              <div className="flex items-start" data-id="element-1174">
                <AlertCircle className="w-5 h-5 text-yellow-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-1175" />
                <p className="text-base text-yellow-800" data-id="element-1176">
                  <strong data-id="element-1177">
                    *There may be a charge for a replacement certificate if
                    necessary information is not provided or snail mail is
                    requested.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}